"use client";

import { Icon } from "@iconify/react";
import { Button } from "@nextui-org/button";
import React, { useEffect, useState } from "react";

const BackToTop = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    });
  }, []);

  const goTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Button
      isIconOnly
      aria-label="Back to Top"
      className={scrolled ? "scrollToTop block" : "hidden"}
      color="primary"
      onClick={goTop}
    >
      <span className="flex items-center justify-center">
        <Icon fontSize={24} icon="material-symbols:keyboard-double-arrow-up" />
      </span>
    </Button>
  );
};

export default BackToTop;
